import React from 'react';
import { logo } from '../../../../constants/images';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  color?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info';
  centered?: boolean;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  centered = false,
}) => {

  
  const spinner = (
    <div >
        <div className="page-loader">
        <img src={logo} alt="Loading"/>
      </div>
          </div>
  );

  if (centered) {
    return (
      <div className="d-flex justify-content-center align-items-center p-4">
        {spinner}
      </div>
    );
  }

  return spinner;
};

export default LoadingSpinner; 